//import React from 'react';

const Check = () => {
    return ("check page");
}

export default Check;